const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Store auth token
export const setAuthToken = (token) => {
  localStorage.setItem('admin_token', token);
};

// Get auth token
export const getAuthToken = () => {
  return localStorage.getItem('admin_token');
};

// Remove auth token
export const removeAuthToken = () => {
  localStorage.removeItem('admin_token');
};

// Check if user is authenticated
export const isAuthenticated = () => {
  return !!localStorage.getItem('admin_token');
};

// Get auth headers
export const getAuthHeaders = () => {
  const token = localStorage.getItem('admin_token');
  return {
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'application/json'
  };
};

// Login
export const login = async (email, password) => {
  const response = await fetch(`${BACKEND_URL}/api/auth/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password })
  });
  
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Login failed');
  }
  
  const data = await response.json();
  setAuthToken(data.access_token);
  return data;
};

// Logout
export const logout = () => {
  removeAuthToken();
  window.location.href = '/admin/login';
};

// Get current user
export const getCurrentUser = async () => {
  const response = await fetch(`${BACKEND_URL}/api/auth/me`, {
    headers: getAuthHeaders()
  });
  
  if (!response.ok) {
    throw new Error('Failed to get user');
  }
  
  return await response.json();
};
